const carouselItems = [
  {
    title: '暑期档必看：十部高分新片推荐',
    desc: '这个暑假不容错过的十部高分好片，从动作到剧情，从国产到进口，总有你的菜。',
    tag: '暑期特辑',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20atmosphere%20with%20warm%20golden%20sunlight%20and%20theater%20vibe%2C%20elegant%20film%20poster%20composition%2C%20rich%20amber%20and%20coral%20tones%2C%20vibrant%20yet%20sophisticated%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=carousel-01-summer&orientation=landscape',
  },
  {
    title: '高分华语剧：国产剧口碑之作',
    desc: '近两年口碑爆棚的高分华语剧集，制作精良、演技在线，国产剧的崛起之作。',
    tag: '华语精选',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20cinematic%20atmosphere%20with%20warm%20lighting%2C%20classic%20composition%2C%20rich%20cultural%20texture%2C%20golden%20amber%20and%20deep%20red%20accents%2C%20premium%20film%20aesthetic%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=carousel-02-chinese&orientation=landscape',
  },
  {
    title: '奥斯卡获奖影片全收录',
    desc: '历届奥斯卡最佳影片、最佳外语片高清合集，影迷不可错过的殿堂级作品。',
    tag: '获奖佳作',
    img: 'https://readdy.ai/api/search-image?query=Prestigious%20award%20ceremony%20cinematic%20atmosphere%20with%20golden%20statue%20and%20warm%20spotlight%2C%20elegant%20red%20carpet%20vibe%2C%20rich%20gold%20and%20amber%20lighting%2C%20luxurious%20film%20aesthetic%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=carousel-03-oscar&orientation=landscape',
  },
  {
    title: '韩国电影：豆瓣高分推荐',
    desc: '从寄生虫到釜山行，韩国电影近年佳作不断。精选豆瓣8分以上韩影高清合集。',
    tag: '韩影精选',
    img: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20atmosphere%20with%20dramatic%20warm%20lighting%2C%20elegant%20film%20poster%20composition%2C%20sophisticated%20dark%20and%20amber%20contrast%2C%20premium%20movie%20aesthetic%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=carousel-04-korean&orientation=landscape',
  },
  {
    title: '豆瓣Top250经典影片合集',
    desc: '影史经典一网打尽，豆瓣Top250高分电影高清合集，影迷必修课就在这里。',
    tag: '经典必看',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20collection%20atmosphere%20with%20warm%20golden%20cinematic%20lighting%2C%20elegant%20vintage%20movie%20poster%20composition%2C%20rich%20amber%20and%20sepia%20tones%2C%20timeless%20cinema%20aesthetic%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=carousel-05-top250&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              精选专题片单，一次看够同类型高分佳作
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.slice(0, 3).map((item, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/40 transition-all cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
            {carouselItems.slice(3).map((item, i) => (
              <div
                key={i + 3}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/40 transition-all cursor-pointer flex flex-col sm:flex-row"
              >
                <div className="relative sm:w-48 md:w-56 aspect-[3/2] sm:aspect-auto overflow-hidden flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex flex-col justify-center">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}